import React from 'react';
import ServicePage from '../components/services/ServicePage';
import windowPrivacyFilm from '../data/services/window-privacy-film';

const WindowPrivacyFilm: React.FC = () => <ServicePage data={windowPrivacyFilm} />;

export default WindowPrivacyFilm;
